import React from 'react';
import { ThemeProvider } from '@emotion/react';
import themeIFProfs, {
  LIGHT_GREY_COLOR,
  PRIMARY_CURRENT_COLOR,
} from '../components/presentational/ThemeIFProfs';
import Head from 'next/head';
import BreadcrumbAndHeading from '../components/presentational/BreadcrumbAndHeading';
import Document from '../components/presentational/img/icons/Document-big-full.svg';
import Breadcrumb from '../components/presentational/Breadcrumb';
import BreadcrumbItem from '../components/presentational/BreadcrumbItem';
import Link from 'next/link';
import H1 from '../components/presentational/H1';
import Slice from '../components/presentational/FullColoredSlice';
import MainGreyBackground from '../components/presentational/MainGreyBackground';
import Grid from '../components/presentational/Grid';
import GridColumn from '../components/presentational/GridColumn';
import MainColumn from '../components/presentational/MainColumn';
import MainColumnSlice from '../components/presentational/MainColumnSlice';
import P from '../components/presentational/P';
import FooterWorld from '../components/app/FooterWorld';

export default function Page404() {
  return (
    <ThemeProvider theme={themeIFProfs}>
      <Head>
        <title>Page non trouvée | IFprofs</title>
        <meta name="robots" content="noindex, follow" key="robots" />
      </Head>
      <BreadcrumbAndHeading bgIcon={Document.src}>
        <Breadcrumb>
          <BreadcrumbItem>
            <Link
              passHref
              href={{
                pathname: '/',
              }}
              as={`/`}
            >
              <BreadcrumbItem.A>Accueil</BreadcrumbItem.A>
            </Link>
          </BreadcrumbItem>
          <BreadcrumbItem>Page non trouvée</BreadcrumbItem>
        </Breadcrumb>
        <H1>Page non trouvée</H1>
      </BreadcrumbAndHeading>
      <Slice
        customColor={PRIMARY_CURRENT_COLOR}
        withBackgroundImage
        paddingBottom="1rem"
      >
        <MainGreyBackground>
          <Grid>
            <GridColumn xs={12 / 12} md={8 / 12}>
              <MainColumn backgroundColor="#f8f9f9" isMarginTopNegative>
                <MainColumnSlice withGutters backgroundColor={LIGHT_GREY_COLOR}>
                  <P>La page demandée n'a pas pu être trouvée.</P>
                </MainColumnSlice>
              </MainColumn>
            </GridColumn>
          </Grid>
        </MainGreyBackground>
      </Slice>

      {<FooterWorld />}
    </ThemeProvider>
  );
}
